//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectTaggedObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[0,"PreviewProximityResults",1,0],[0,"ProximityEvalType",1,0],[1,"ProximityExclusionSize",0,"Expression",0],[1,"ProximityRange",0,"Expression",0],[1,"ProximityTargets",0,"SelectTaggedObjectList",0],[0,"Type",1,0]],[[[],"EvaluateProximity",{},0,0]],[]];
SPLM.Assemblies.OpenByProximityBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.OpenByProximityBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.OpenByProximityBuilder.Types = Object.freeze({
    "ProximityInformationFromPartFile" : "ProximityInformationFromPartFile", "ProximityInformationFromTeamcenter" : "ProximityInformationFromTeamcenter"});

SPLM.Assemblies.OpenByProximityBuilder.ProximityEvalLevel = Object.freeze({
    "BoundingBox" : "BoundingBox", "TrueShape" : "TrueShape"});

SPLM.Assemblies.OpenByProximityBuilder.TargetValidity = Object.freeze({
    "Valid" : "Valid", "LacksBBox" : "LacksBBox", "CannotMapToTC" : "CannotMapToTC", "ReferenceOnly" : "ReferenceOnly", "NativePartInManagedMode" : "NativePartInManagedMode"});

export default SPLM;